import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7cb2de88 from 'nuxt_plugin_plugin_7cb2de88' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_64f8f5cd from 'nuxt_plugin_bootstrapvue_64f8f5cd' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_sentryserver_2fd1d762 from 'nuxt_plugin_sentryserver_2fd1d762' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_6bcf344c from 'nuxt_plugin_sentryclient_6bcf344c' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_pluginclient_21122604 from 'nuxt_plugin_pluginclient_21122604' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_f268d0e8 from 'nuxt_plugin_pluginserver_f268d0e8' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginutils_60e4085d from 'nuxt_plugin_pluginutils_60e4085d' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_6e03f268 from 'nuxt_plugin_pluginrouting_6e03f268' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_54485207 from 'nuxt_plugin_pluginmain_54485207' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_workbox_1eebc98c from 'nuxt_plugin_workbox_1eebc98c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_5719884d from 'nuxt_plugin_metaplugin_5719884d' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_axios_22eed4c4 from 'nuxt_plugin_axios_22eed4c4' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_buffer_591ab6f8 from 'nuxt_plugin_buffer_591ab6f8' // Source: ./nuxt-polyfill/buffer.js (mode: 'all')
import nuxt_plugin_moment_1d94a08c from 'nuxt_plugin_moment_1d94a08c' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_vueswal_9db69a28 from 'nuxt_plugin_vueswal_9db69a28' // Source: ../plugins/vue-swal (mode: 'all')
import nuxt_plugin_vueuuid_9db4d5d0 from 'nuxt_plugin_vueuuid_9db4d5d0' // Source: ../plugins/vue-uuid (mode: 'all')
import nuxt_plugin_currency_15633587 from 'nuxt_plugin_currency_15633587' // Source: ../plugins/currency (mode: 'all')
import nuxt_plugin_bridge_0ecb63cc from 'nuxt_plugin_bridge_0ecb63cc' // Source: ../plugins/bridge.client (mode: 'client')
import nuxt_plugin_mixins_2e01f171 from 'nuxt_plugin_mixins_2e01f171' // Source: ../plugins/mixins.client (mode: 'client')
import nuxt_plugin_offline_62608b2c from 'nuxt_plugin_offline_62608b2c' // Source: ../plugins/offline.client (mode: 'client')
import nuxt_plugin_socketio_f2f4d9a2 from 'nuxt_plugin_socketio_f2f4d9a2' // Source: ../plugins/socket-io.client (mode: 'client')
import nuxt_plugin_initdata_5d2964c8 from 'nuxt_plugin_initdata_5d2964c8' // Source: ../plugins/init-data.client (mode: 'client')
import nuxt_plugin_vueselect_61fca840 from 'nuxt_plugin_vueselect_61fca840' // Source: ../plugins/vue-select.client (mode: 'client')
import nuxt_plugin_timemachine_43e19955 from 'nuxt_plugin_timemachine_43e19955' // Source: ../plugins/timemachine.client (mode: 'client')
import nuxt_plugin_veevalidate_2581ec36 from 'nuxt_plugin_veevalidate_2581ec36' // Source: ../plugins/vee-validate.client (mode: 'client')
import nuxt_plugin_domtoimage_e975dfe2 from 'nuxt_plugin_domtoimage_e975dfe2' // Source: ../plugins/dom-to-image.client (mode: 'client')
import nuxt_plugin_vueobservevisibility_9bd06b0e from 'nuxt_plugin_vueobservevisibility_9bd06b0e' // Source: ../plugins/vue-observe-visibility.client (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"PosBytz Complete"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7cb2de88 === 'function') {
    await nuxt_plugin_plugin_7cb2de88(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_64f8f5cd === 'function') {
    await nuxt_plugin_bootstrapvue_64f8f5cd(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_2fd1d762 === 'function') {
    await nuxt_plugin_sentryserver_2fd1d762(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_6bcf344c === 'function') {
    await nuxt_plugin_sentryclient_6bcf344c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_21122604 === 'function') {
    await nuxt_plugin_pluginclient_21122604(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_f268d0e8 === 'function') {
    await nuxt_plugin_pluginserver_f268d0e8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_60e4085d === 'function') {
    await nuxt_plugin_pluginutils_60e4085d(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_6e03f268 === 'function') {
    await nuxt_plugin_pluginrouting_6e03f268(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_54485207 === 'function') {
    await nuxt_plugin_pluginmain_54485207(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_1eebc98c === 'function') {
    await nuxt_plugin_workbox_1eebc98c(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_5719884d === 'function') {
    await nuxt_plugin_metaplugin_5719884d(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_22eed4c4 === 'function') {
    await nuxt_plugin_axios_22eed4c4(app.context, inject)
  }

  if (typeof nuxt_plugin_buffer_591ab6f8 === 'function') {
    await nuxt_plugin_buffer_591ab6f8(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_1d94a08c === 'function') {
    await nuxt_plugin_moment_1d94a08c(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (typeof nuxt_plugin_vueswal_9db69a28 === 'function') {
    await nuxt_plugin_vueswal_9db69a28(app.context, inject)
  }

  if (typeof nuxt_plugin_vueuuid_9db4d5d0 === 'function') {
    await nuxt_plugin_vueuuid_9db4d5d0(app.context, inject)
  }

  if (typeof nuxt_plugin_currency_15633587 === 'function') {
    await nuxt_plugin_currency_15633587(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bridge_0ecb63cc === 'function') {
    await nuxt_plugin_bridge_0ecb63cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mixins_2e01f171 === 'function') {
    await nuxt_plugin_mixins_2e01f171(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_offline_62608b2c === 'function') {
    await nuxt_plugin_offline_62608b2c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_socketio_f2f4d9a2 === 'function') {
    await nuxt_plugin_socketio_f2f4d9a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_initdata_5d2964c8 === 'function') {
    await nuxt_plugin_initdata_5d2964c8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueselect_61fca840 === 'function') {
    await nuxt_plugin_vueselect_61fca840(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_timemachine_43e19955 === 'function') {
    await nuxt_plugin_timemachine_43e19955(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_2581ec36 === 'function') {
    await nuxt_plugin_veevalidate_2581ec36(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_domtoimage_e975dfe2 === 'function') {
    await nuxt_plugin_domtoimage_e975dfe2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueobservevisibility_9bd06b0e === 'function') {
    await nuxt_plugin_vueobservevisibility_9bd06b0e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
